// shared/store/persistStorage.ts
import { createJSONStorage } from 'zustand/middleware';

function safeStorage(): Storage {
  if (typeof window !== 'undefined' && window.localStorage) return window.localStorage;

  // Memory fallback that matches the Storage interface (sync)
  const mem: Record<string, string> = {};
  return {
    getItem: (key: string) => (key in mem ? mem[key] : null),
    setItem: (key: string, value: string) => {
      mem[key] = String(value);
    },
    removeItem: (key: string) => {
      delete mem[key];
    },
    clear: () => {
      for (const k of Object.keys(mem)) delete mem[k];
    },
    key: (index: number) => Object.keys(mem)[index] ?? null,
    get length() {
      return Object.keys(mem).length;
    },
  } as Storage;
}

export const jsonStorage = () => createJSONStorage<unknown>(() => safeStorage());
